// for custom country/language selectors from https://shopify.dev/themes/internationalization/multiple-currencies-languages
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      inputCountry: this.querySelector('input[name="country_code"]'),
      inputLanguage: this.querySelector('input[name="language_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.rootNode = this.elements.button.closest('div');
    this.mobileMenu = this.elements.panel.id === 'CountryListMobile' ? true : false;
    this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
    if(this.mobileMenu) {
      document.querySelector('#mobileMenuClose').addEventListener('click', this.closeSelector.bind(this));
    }
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a.lang_switcher').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE' && event.code.toUpperCase() !== 'ESC') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.inputCountry.value = event.currentTarget.dataset.value;
    this.elements.inputLanguage.value = event.currentTarget.dataset.lang;

    if (this.elements.inputCountry.value === 'US' || this.elements.inputCountry.value === 'CA' ) {
      form.action = "/localization";
    } else {
      form.action = "https://international.kamadojoe.com/localization"
    }

    if (form && form.action) {
      form.submit();
}
  }

  toggleSelector(event) {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    if (this.elements.panel.getAttribute('hidden') === null) {
      this.elements.button.setAttribute('aria-expanded', 'true');
      if (!this.mobileMenu) {
        document.addEventListener('click', this.onBlur.bind(this));
      }
    } else {
      this.elements.button.setAttribute('aria-expanded', 'false');
      if (!this.mobileMenu) {
        document.removeEventListener('click', this.onBlur);
      }
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    const blurred = this.rootNode.contains(event.relatedTarget);
    if (event.relatedTarget === null || shouldClose || blurred) {
      this.hidePanel();
    }
  }

  onBlur(event) {
    if (event.target === this.elements.button) {
      return;
    }
    let menuContainsFocus = this.rootNode.contains(event.relatedTarget);
    let clickedOutside = !this.rootNode.contains(event.target);
    if (!menuContainsFocus && clickedOutside) {
      this.toggleSelector();
    }
  }
}

customElements.define('localization-form', LocalizationForm);